import React from 'react'
import PropTypes from 'prop-types'
import LoaderSpinner from 'react-loader-spinner'

const SpinLoader = ({
  type, color, height, width,
}) => (
  <div className='text-center mt-5'>
    <LoaderSpinner
      type={ type }
      color={ color }
      height={ height }
      width={ width }
    />
  </div>
)

export default SpinLoader

SpinLoader.defaultProps = {
  type: 'Circles', color: '#343A40', height: 100, width: 100,
}

SpinLoader.propTypes = {
  type: PropTypes.string,
  color: PropTypes.string,
  height: PropTypes.number,
  width: PropTypes.number,
}
